// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"229":"6cb9f654","472":"b6abec7e","596":"77815c92","720":"07b91856","896":"50eae0af","959":"32098cd5"}[chunkId] + ".css";
};